<template>
  <div class="login">
    <div class="container">
      <div class="login__header">
        <img class="login__logo" src="@images/logo.png" alt="logo">
      </div>
    </div>
    <div class="login__wrapper">
      <div class="container">
        <form class="login__form" @submit.prevent="send">
          <h1>LOG IN</h1>
          <p>Welcome! Let's create together.</p>
          <ui-input
              :type="'email'"
              :placeholder="'Your Email'"
              :rules="[isEmail]"
              v-model="email"
          />
          <ui-input
              :type="'password'"
              :placeholder="'Your Password'"
              :rules="[isPasswordValid]"
              v-model="password"
          />
          <button class="login__button" type="submit" :disabled="!isFormValid">Log In</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {ElNotification} from "element-plus";
import {isEmail, isPasswordValid} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";

const email = ref('')
const password = ref('')

const isFormValid = computed(() => {
  return (
    isEmail(email.value) === true &&
    isPasswordValid(password.value) === true
  )
})

const send = () => {
  ElNotification({
    message: 'This account does not exist.',
    type: 'error'
  })
}
</script>

<style lang="scss" scoped>
.login {
  background-image: url(@images/mainBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  height: 100vh;

  &__header {
    padding-block: 32px;
  }

  &__wrapper {
    display: grid;
    place-items: center;
  }

  &__form {
    margin-top: 100px;
    width: 738px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-inline: auto;

    & h1 {
      color: #252641;
      text-align: center;
      font-size: 36px;
      font-weight: 500;
      letter-spacing: 1.44px;
    }

    & p {
      color: #252641;
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.8px;
    }
  }

  &__button {
    cursor: pointer;
    margin-top: 30px;
    border-radius: 60px;
    background: linear-gradient(106deg, #545AE7 19.57%, #393FCF 78.85%);
    padding: 16px 50px;
    transition: 0.2s;

    color: #FFF2E1;
    text-align: center;
    font-size: 22px;
    font-weight: 500;

    @include hover {
      box-shadow: 0 0 10px 1px #545AE7;
    }

    &:disabled {
      cursor: not-allowed;
      background: #777777;

      @include hover {
        box-shadow: 0 0 0 0 #545AE7;
      }
    }
  }
}

@media (max-width: 850px) {
  .login {
    &__form {
      width: 100%;
    }
  }
}

@media (max-width: 400px) {
  .login {
    &__logo {
      width: 300px;
    }
  }
}
</style>